<div class="p-container">
  <sxw-form #formElm [formModel]="formModel">
    <app-profile-form
      [onResetPassword]="openResetPasswordPopup.bind(this)"
      [onDeleteAccount]="openDeleteAccountpopup.bind(this)"
      [saveProfileChanges]="saveProfileChanges.bind(this)"
      [onUpdateEmail]="onUpdateEmail.bind(this)">
      >
    </app-profile-form>
  </sxw-form>
  <router-outlet name="popups"></router-outlet>
</div>
